<template>
  <div
    class="page-header section-dark"
    :style="{
      'background-image': 'url(' + require('../assets/img/mountain.jpeg') + ')',
      'background-image':
        'linear-gradient(rgba(0, 0, 0, 0.2),rgba(0, 0, 0, 0.2)), url(' +
        require('../assets/img/mountain.jpeg') +
        ')',
    }"
  >
    <div class="banner">
      <h2>
        Welcome to <b class="highlighted-text">The Cloud People Healthclub</b>
      </h2>
      <br />

      <span class="info-text">
        Healthy employees are happy employees. We all know that regular exercise
        releases mood-elevating endorphins, gives us more energy, reduces stress
        and the likelihood of becoming sick. TCP Health Club is aimed at
        stimulating you and your colleagues to stay active at least 30 min a
        day. Join us in making TCP the healthiest Google and ServiceNow company
        in the market.
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  methods: {},
};
</script>

<style scoped>
.section-dark {
  overflow: hidden;
}


</style>
